﻿import $ from "jquery";
import { GuiDetailGeneric } from "../../GuiDetailGeneric";

export class GuiDetailAbrechnungAktion extends GuiDetailGeneric {

    constructor() {
        super("AbrechnungAktion");

        $("#btnBarSave").off("click");

        $("#btnBarSave").on("click", () => {
            const url = $("form").data("urlsave");
            if (url == undefined) return;
            document.location.href = url;
        });
    }
}
